<template>
  <VForm
    v-model="filterData"
    class="form-filter"
    ref="filterData"
    @request="filterSubmit"
  >

    <div class="grid-filter mb-30">
      <VSelect
        label="Материалы:"
        name="materials"
        item-text=""
        :options="filterOptions.materials"
        multiple
        searchable
      />

      <VSelect
        label="Диаметры:"
        name="d_wires"
        item-text=""
        :options="filterOptions.d_wires"
        multiple
        searchable
      />

      <VInput
        label="Номер заказа:"
        name="account_number"
        @input="(val) => {
          if (val === '') filterData.account_number = null
        }"
      />

      <VCheckbox
        name="only_min"
        label="Только малый остаток"
        class="filter__checkbox"
      />
    </div>

    <div class="buttons button-group">
      <VButton text="Применить" type="submit" :class="{ 'btn--100': isMobile }" color="primary" />

      <VButton text="Сбросить" :class="{ 'btn--100': isMobile }" @click.native="onClickResetBtn" />
    </div>
  </VForm>
</template>

<script>
import VForm from '@/components/Form/VForm.vue'
import VCheckbox from '@/components/Form/VCheckbox.vue'
import VSelect from '@/components/Form/VSelect.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import VButton from '@/components/simple/button/VButton.vue'
import VInput from '@/components/Form/Vinput/VInput.vue'

export default {
  name: 'MaterialFilter',
  components: { VInput, VButton, VSelect, VCheckbox, VForm },

  data () {
    return {
      filterData: {
        d_wires: null,
        materials: null,
        account_number: null,
        only_min: false
      }
    }
  },

  computed: {
    ...mapGetters('warehouse', {
      filterOptions: 'material/filterOptions',
      savedFilter: 'material/filter'
    }),
    ...mapState('mobile', {
      isMobile: 'isMobile'
    })
  },

  mounted () {
    if (this.savedFilter) {
      this.filterData.d_wires = this.savedFilter.d_wires || null
      this.filterData.materials = this.savedFilter.materials || null
      this.filterData.account_number = this.savedFilter.account_number || null
      this.filterData.only_min = this.savedFilter.only_min || false
    }
  },

  methods: {
    ...mapMutations('warehouse', {
      SET_FILTER: 'material/SET_FILTER',
      RESET_FILTER: 'material/RESET_FILTER'
    }),

    async filterSubmit (data) {
      if (data.only_min === false) {
        delete data.only_min
      }

      this.SET_FILTER(data)
      this.$emit('closeModal')
      this.$emit('loadList')
    },

    async onClickResetBtn () {
      this.filterData.materials = null
      this.filterData.d_wires = null
      this.filterData.account_number = null
      this.filterData.only_min = false
      this.filterData = {}
      this.RESET_FILTER()
      this.$emit('closeModal')
      this.$emit('loadList')
    }
  }
}
</script>
